const LOCATOR_KEY = 'cohort-definition-summary';
const ACCORDION_SUMMARY = 'accordion-summary';
const ACCORDION_DETAILS = 'accordion-details';

export const useCohortDefinitionLocators = () => {
  return {
    indexDateAccordionId: `index-date-${LOCATOR_KEY}`,
    indexDateAccordionSummaryId: `index-date-${ACCORDION_SUMMARY}--${LOCATOR_KEY}`,
    indexDateAccordionDetailsId: `index-date-${ACCORDION_DETAILS}--${LOCATOR_KEY}`,

    studyPeriodAccordionId: `study-period-${LOCATOR_KEY}`,
    studyPeriodAccordionSummaryId: `study-period-${ACCORDION_SUMMARY}--${LOCATOR_KEY}`,
    studyPeriodAccordionDetailsId: `study-period-${ACCORDION_DETAILS}--${LOCATOR_KEY}`,

    inclusionCriteriaAccordionId: `inclusion-criteria-${LOCATOR_KEY}`,
    inclusionCriteriaAccordionSummaryId: `inclusion-criteria-${ACCORDION_SUMMARY}--${LOCATOR_KEY}`,
    inclusionCriteriaAccordionDetailsId: `inclusion-criteria-${ACCORDION_DETAILS}--${LOCATOR_KEY}`,

    exclusionCriteriaAccordionId: `exclusion-criteria-${LOCATOR_KEY}`,
    exclusionCriteriaAccordionSummaryId: `exclusion-criteria-${ACCORDION_SUMMARY}--${LOCATOR_KEY}`,
    exclusionCriteriaAccordionDetailsId: `exclusion-criteria-${ACCORDION_DETAILS}--${LOCATOR_KEY}`,

    eventsAccordionId: `events-${LOCATOR_KEY}`,
    eventsAccordionSummaryId: `events-${ACCORDION_SUMMARY}--${LOCATOR_KEY}`,
    eventsAccordionDetailsId: `events-${ACCORDION_DETAILS}--${LOCATOR_KEY}`,

    conceptGroupsAccordionId: `concept-groups-${LOCATOR_KEY}`,
    conceptGroupsAccordionSummaryId: `concept-groups-${ACCORDION_SUMMARY}--${LOCATOR_KEY}`,
    conceptGroupsAccordionDetailsId: `concept-groups-${ACCORDION_DETAILS}--${LOCATOR_KEY}`,
  };
};
